import React from 'react';
import { NumericFormat } from 'react-number-format';
import { keycloak } from '../../../../lib/keycloak';
import Input from '../../../../ui/molecules/input';
import { SelectCustom } from '../../../../ui/molecules/select';

interface ComparisonFieldProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
}

export const ComparisonFieldEmployees: React.FC<ComparisonFieldProps> = ({
    value,
    onChange,
    label,
    placeholder = "Inserisci valore",
    disabled,
    error
}) => {
    const [operator, minValue, maxValue] = value.split(':');

    const handleOperatorChange = (newOperator: string) => {
        const newValue = `${newOperator}:undefined:undefined`;
        onChange(newValue);
    };

    const handleMinChange = (newMin: string) => {
        const newValue = `${operator}:${newMin || 'undefined'}:${maxValue}`;
        onChange(newValue);
    };

    const handleMaxChange = (newMax: string) => {
        const newValue = `${operator}:${minValue}:${newMax || 'undefined'}`;
        onChange(newValue);
    };

    const signMap = new Map<("=" | "<" | ">" | "><"), string>([
        ["=", "Uguale a"],
        ["<", "Minore di"],
        [">", "Maggiore di"],
        ["><", "Compreso tra"],
    ]);

    return (
        <div className="flex gap-4 items-start justify-start">
            <div className="w-full">
                <SelectCustom
                    isClearable
                    defaultValue={operator}
                    onChange={(e) => handleOperatorChange(e ? e.toString() : 'undefined')}
                    disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                    placeholder={"Indifferente"}
                    options={[
                        { label: "Uguale a", value: "=" },
                        { label: "Minore di", value: "<" },
                        { label: "Maggiore di", value: ">" },
                        { label: "Compreso tra", value: "><" },
                    ]}
                    label="Numero dipendenti"
                />
            </div>
            <div className="w-full">
                {operator !== 'undefined' && (
                    <NumericFormat
                        value={minValue === 'undefined' ? '' : minValue}
                        thousandSeparator="."
                        decimalSeparator=","
                        onValueChange={(e) => handleMinChange(e.value)}
                        decimalScale={0}
                        disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                        fixedDecimalScale
                        label={signMap.get(operator as "=" | "<" | ">" | "><") || ""}
                        error={error}
                        supportingText={error ? "Inserire il numero di dipendenti" : ""}
                        customInput={Input}
                        id={"employees-to-confirm-price-min"}
                        key={"employees-to-confirm-price-min"} />
                )}
            </div>
            <div className="w-full">
                {operator === '><' && (
                    <NumericFormat
                        value={maxValue === 'undefined' ? '' : maxValue}
                        thousandSeparator="."
                        decimalSeparator=","
                        onValueChange={(e) => handleMaxChange(e.value)}
                        decimalScale={0}
                        disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
                        fixedDecimalScale
                        label={signMap.get(operator as "=" | "<" | ">" | "><") || ""}
                        error={error}
                        supportingText={error ? "Inserire il numero di dipendenti" : ""}
                        customInput={Input}
                        id={"employees-to-confirm-price-max"}
                        key={"employees-to-confirm-price-max"}
                    />
                )}
            </div>
        </div>
    );
};